export enum YesNoEnum {
  Yes = 1,
  No,
}
